import React from 'react';
import { ChevronLeft } from '../Icon';
import Checkbox from '../Checkbox';

import styles from './PreviewAddress.module.scss';

interface PreviewAddressProps {
  title: string;
  firstName: string;
  lastName: string;
  addressLine1: string;
  addressLine2?: string;
  city: string;
  state?: string;
  country: string;
  zipCode: string;
  contactNumber?: string;
  isDefault: boolean;
  onBack: () => void;
  onSave: (payload: any) => void;
  payload: any;
}

const PreviewAddress: React.FC<PreviewAddressProps> = ({
  title,
  firstName,
  lastName,
  addressLine1,
  addressLine2,
  city,
  state,
  country,
  zipCode,
  contactNumber,
  isDefault,
  onBack,
  onSave,
  payload,
}) => (
  <div className={styles.content}>
    <div className={styles.header}>
      <ChevronLeft onClick={onBack} />
      <h1>{title}</h1>
      <button onClick={() => onSave(payload)}>Save</button>
    </div>
    <h2>Primary Shipping Address</h2>
    <ul>
      <li>{firstName}</li>
      <li>{lastName}</li>
      <li>{addressLine1}</li>
      {addressLine2 && <li>{addressLine2}</li>}
      <li>{city}</li>
      {state && <li>{state}</li>}
      <li>{country}</li>
      <li>{zipCode}</li>
      {contactNumber && <li>{contactNumber}</li>}
      {isDefault && (
        <li>
          <Checkbox label="Make Primary Shipping Address" checked name="primaryAddress" />
        </li>
      )}
    </ul>
  </div>
);

export default PreviewAddress;
